import React, { Component } from "react";


const ToolBox = ({ deleteRow, openInputConfig }) => {
    return (
        <div className="toolBox blur-back" >
            <div onMouseUp={(e) => { e.stopPropagation(); openInputConfig() }}>
                <img
                    src="/assets/icons/edit-pencil.png"
                    alt="edit"
                    className="icon-img"
                />
            </div>
            <div onMouseUp={(e) => { e.stopPropagation(); deleteRow() }}>
                <img
                    src="/assets/icons/trash.png"
                    alt="trash"
                    className="icon-img"
                />
            </div>
            <div>
                <span>More</span>
                <img
                    src="/assets/icons/down-arrow.png"
                    alt=""
                    className="arrow-down"
                />
            </div>
        </div>
    );
};

export default ToolBox;